import { z } from "zod";

export interface ParsedTaskLink {
    taskId: string;
    workspaceId: string | null;
}

const taskIdSchema = z.string().uuid();

/**
 * Reads a pasted link to a task: a same-origin URL with a `taskId` param,
 * and the task's workspace in `taskWorkspaceId` or `workspaceId` when given.
 */
export function parseTaskLink({
    text,
    origin,
}: {
    text: string;
    origin: string;
}): ParsedTaskLink | null {
    const trimmed = text.trim();
    if (/\s/.test(trimmed)) {
        return null;
    }
    let url: URL;
    try {
        url = new URL(trimmed);
    } catch {
        return null;
    }
    if (url.origin !== origin) {
        return null;
    }
    const taskId = taskIdSchema.safeParse(url.searchParams.get("taskId"));
    if (!taskId.success) {
        return null;
    }
    return {
        taskId: taskId.data,
        workspaceId:
            url.searchParams.get("taskWorkspaceId") ??
            url.searchParams.get("workspaceId"),
    };
}
